export const SET_REFERRAL_OPTIONS = "SET_REFERRAL_OPTIONS";
export const SET_PATIENT_ID = "SET_PATIENT_ID";
export const SET_ACCOUNT_ID = "SET_ACCOUNT_ID";
export const SET_PATIENT_DETAILS = "SET_PATIENT_DETAILS";
export const SET_APPLICATION = "SET_APPLICATION";
export const SET_COUNTRY_LIST = "SET_COUNTRY_LIST";
export const SET_PATIENT_REFERRAL_ID = "SET_PATIENT_REFERRAL_ID";
